import { type PropsWithChildren, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { IS_OFFLINE_TOAST_ID, IS_ONLINE_TOAST_ID } from '~sharedConfig'

const Controller = () => {
	const [isOnline, setIsOnline] = useState(window.navigator.onLine)

	useEffect(() => {
		const setOnline = () => {
			if (!isOnline) {
				toast.success('Соединение восстановлено', { toastId: IS_ONLINE_TOAST_ID })
				toast.dismiss(IS_OFFLINE_TOAST_ID)
			}
			setIsOnline(true)
		}
		const setOffline = () => {
			if (isOnline)
				toast.error('Соединение разорвано', { toastId: IS_OFFLINE_TOAST_ID })
			setIsOnline(false)
		}

		window.addEventListener('online', setOnline)
		window.addEventListener('offline', setOffline)

		return () => {
			window.removeEventListener('online', setOnline)
			window.removeEventListener('offline', setOffline)
		}
	}, [isOnline])

	return <></>
}

export const BrowserStatusesController = ({ children }: PropsWithChildren) => (
	<>
		<Controller />
		{children}
	</>
)
